var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManthink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3684 3688",
    width: 3684,
    height: 3688,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#92e3a9}.b{opacity:.7;fill:#fff}.c{fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:8}.d{fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:16}.e{fill:#92e3a9;stroke:#263238;stroke-miterlimit:10;stroke-width:8}.f{fill:none;stroke:#263238;stroke-miterlimit:10;stroke-width:4}.g{fill:#263238;stroke:#263238;stroke-miterlimit:10;stroke-width:8}.h{fill:#fff;stroke:#263238;stroke-miterlimit:10;stroke-width:8}.i{fill:#263238}.j{fill:#ccc}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m3379.2 2391.4c0 0 408.7-459.3 278.8-1258.6-130-799.4-797.4-1093.8-1240.2-939.9-442.9 153.9-542.6 421.5-904.3 574.7-361.7 153.2-1048.5 47.9-1392.1 562.3-343.5 514.3 95 1366.6 653.4 1901 558.3 534.4 1983.6 199.8 2604.4-839.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m3379.2 2399.4c0 0 408.7-459.3 278.8-1258.6-130-799.4-797.4-1093.8-1240.2-939.9-442.9 153.9-542.6 421.5-904.3 574.7-361.7 153.2-1048.5 47.9-1392.1 562.3-343.5 514.3 95 1366.6 653.4 1901 558.3 534.4 1983.6 199.8 2604.4-839.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m372.6 3682h3201.3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m869.4 2466.1l127 1214.3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m973.9 3431.3l-56.5-59.7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m934.6 3389.5c0 0 1.6-26.4-22.5-47.9-14.5-12.9-90.8-45-98-18.2-7.9 29.3 70.2 86.6 120.5 66.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m934.6 3389.5l-72.7-45.3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m988 3567l-56.4-59.6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m948.7 3525.2c0 0 1.6-26.3-22.5-47.9-14.4-12.9-90.7-45-98-18.1-7.8 29.2 70.2 86.6 120.5 66z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m948.7 3525.2l-72.6-45.2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m939.3 3100l-56.5-59.6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m900 3058.3c0 0 1.6-26.4-22.5-47.9-14.5-13-90.8-45.1-98-18.2-7.9 29.2 70.2 86.6 120.5 66.1z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m900 3058.3l-72.6-45.3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m953.5 3235.8l-56.5-59.7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m914.2 3194c0 0 1.6-26.4-22.5-47.9-14.5-12.9-90.8-45-98-18.2-7.9 29.3 70.2 86.6 120.5 66.1z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m914.2 3194l-72.7-45.3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m916.3 2879.5l-56.5-59.6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m877 2837.7c0 0 1.6-26.3-22.5-47.9-14.5-12.9-90.8-45-98-18.1-7.9 29.2 70.2 86.6 120.5 66z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m877 2837.7l-72.7-45.2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m893.2 2658l-56.5-59.6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m853.9 2616.3c0 0 1.6-26.4-22.5-47.9-14.5-13-90.8-45.1-98-18.2-7.9 29.2 70.2 86.6 120.5 66.1z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m853.9 2616.3l-72.7-45.3"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m964.4 3351l42.9-70.1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m994.2 3302c0 0-7-25.5 12.1-51.5 11.5-15.7 79.5-62.9 92.2-38.1 13.7 27-50.8 99.3-104.3 89.6z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m994.2 3302l65.4-62.5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m927.1 2993.7l42.9-70"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m956.9 2944.8c0 0-7-25.5 12.1-51.6 11.5-15.6 79.6-62.8 92.2-38 13.7 27-50.8 99.3-104.3 89.6z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m956.9 2944.8l65.4-62.6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m910.7 2836.8l43-70.1"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m940.6 2787.8c0 0-7.1-25.5 12.1-51.5 11.5-15.7 79.5-62.9 92.1-38.1 13.7 27-50.8 99.3-104.2 89.6z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m940.6 2787.8l65.3-62.5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m886.7 2606.6l42.9-70"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m916.5 2557.6c0 0-7-25.5 12.1-51.5 11.5-15.6 79.6-62.8 92.2-38 13.7 27-50.8 99.2-104.3 89.5z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m916.5 2557.6l65.4-62.5"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m868.3 2459.5c0 0-7-25.5 12.1-51.5 11.5-15.7 79.6-62.8 92.2-38 13.7 26.9-50.8 99.2-104.3 89.5z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m868.3 2459.5l65.4-62.5"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m872.1 2462.2c0 0-26.1 4.3-49.9-17.5-14.4-13.1-54.2-85.6-28.2-95.6 28.3-10.8 93.4 60.9 78.1 113.1z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m872.1 2462.2l-55.3-71.6"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m1197.9 2630.5l-105 1049.9"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m1101.4 3596.5l-42.9-70"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m1071.6 3547.5c0 0 7-25.5-12.2-51.5-11.5-15.6-79.5-62.8-92.1-37.9-13.8 26.9 50.8 99.2 104.3 89.4z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m1071.6 3547.5l-61.8-59.2"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m1135.8 3265.2l-43-70"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m1106 3216.2c0 0 7-25.4-12.2-51.5-11.5-15.6-79.5-62.7-92.2-37.9-13.7 27 50.9 99.2 104.4 89.4z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m1106 3216.2l-61.8-59.2"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m1121.7 3401l-42.9-70"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m1091.9 3352c0 0 7-25.5-12.2-51.5-11.5-15.7-79.5-62.8-92.1-38-13.8 27 50.8 99.2 104.3 89.5z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m1091.9 3352l-61.8-59.2"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m1158.7 3044.7l-43-70"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m1128.8 2995.7c0 0 7-25.5-12.1-51.5-11.5-15.6-79.6-62.7-92.2-37.9-13.7 26.9 50.9 99.2 104.3 89.4z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m1128.8 2995.7l-61.7-59.2"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m1181.7 2823.2l-43-70"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m1151.8 2774.2c0 0 7-25.4-12.1-51.5-11.5-15.6-79.6-62.7-92.2-37.9-13.7 26.9 50.9 99.2 104.3 89.4z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m1151.8 2774.2l-61.7-59.2"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m1108.7 3515.9l56.4-59.6"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m1148 3474.1c0 0-1.6-26.3 22.4-47.9 14.5-12.9 90.8-45.1 98-18.2 7.9 29.2-70.1 86.7-120.4 66.1z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m1148 3474.1l76.8-47.7"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m1145.8 3158.7l56.4-59.7"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m1185.1 3116.9c0 0-1.7-26.4 22.4-47.9 14.5-13 90.8-45.1 98-18.2 7.9 29.2-70.1 86.6-120.4 66.1z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m1185.1 3116.9l76.8-47.7"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m1162.1 3001.7l56.4-59.7"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m1201.3 2959.9c0 0-1.6-26.4 22.5-47.9 14.5-13 90.7-45.1 98-18.2 7.9 29.2-70.2 86.6-120.5 66.1z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m1201.3 2959.9l76.9-47.7"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m1185.9 2771.6l56.5-59.7"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m1225.2 2729.8c0 0-1.6-26.4 22.5-48 14.5-12.9 90.7-45 98-18.2 7.9 29.2-70.2 86.7-120.5 66.2z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m1225.2 2729.8l76.9-47.7"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m1198.3 2623.8c0 0-1.7-26.4 22.4-47.9 14.5-13 90.8-45.1 98-18.3 7.9 29.3-70.1 86.7-120.4 66.2z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m1198.3 2623.8l76.8-47.7"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m1201.4 2627.2c0 0-26.4-1.1-45.3-27.3-11.3-15.8-35.3-95-7.8-99.4 29.9-4.8 78.8 78.8 53.1 126.7z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m1201.4 2627.2l-39.4-81.4"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m1056 2144.4l-7.8 1537.8"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m1057.2 3426.9l-50-65.2"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m1022.4 3381.3c0 0 4.4-26.1-17.4-50-13-14.4-85.6-54.2-95.6-28.2-10.8 28.2 60.9 93.4 113 78.2z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m1022.4 3381.3l-67.5-52.6"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m1057.2 3143.3l-50-65.2"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m1022.4 3097.6c0 0 4.4-26-17.4-49.9-13-14.4-85.6-54.3-95.6-28.3-10.8 28.3 60.9 93.4 113 78.2z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m1022.4 3097.6l-67.5-52.5"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m1057.2 2810.2l-50-65.2"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m1022.4 2764.6c0 0 4.4-26.1-17.4-50-13-14.4-85.6-54.2-95.6-28.2-10.8 28.2 60.9 93.4 113 78.2z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m1022.4 2764.6l-67.5-52.6"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m1057.2 2588.5l-50-65.2"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m1022.4 2542.9c0 0 4.4-26.1-17.4-50-13-14.4-85.6-54.2-95.6-28.2-10.8 28.2 60.9 93.4 113 78.2z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m1022.4 2542.9l-67.5-52.6"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m1057.2 2365.8l-50-65.2"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m1022.4 2320.2c0 0 4.4-26.1-17.4-50-13-14.4-85.6-54.2-95.6-28.2-10.8 28.2 60.9 93.4 113 78.2z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m1022.4 2320.2l-67.5-52.5"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m1056.1 3513.5l50-65.1"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m1090.8 3467.9c0 0-4.3-26.1 17.4-50 13.1-14.3 85.6-54.2 95.6-28.2 10.9 28.2-60.8 93.4-113 78.2z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m1090.8 3467.9l71.6-55.4"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m1056.1 3062.4l50-65.2"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m1090.8 3016.8c0 0-4.3-26.1 17.4-50 13.1-14.4 85.6-54.2 95.6-28.3 10.9 28.3-60.8 93.5-113 78.3z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m1090.8 3016.8l71.6-55.4"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m1056.1 2839.7l50-65.2"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m1090.8 2794.1c0 0-4.3-26.1 17.4-50 13.1-14.4 85.6-54.2 95.6-28.2 10.9 28.2-60.8 93.4-113 78.2z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m1090.8 2794.1l71.6-55.4"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m1056.1 2545.4l50-65.2"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m1090.8 2499.8c0 0-4.3-26.1 17.4-50 13.1-14.4 85.6-54.2 95.6-28.3 10.9 28.3-60.8 93.5-113 78.3z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m1090.8 2499.8l71.6-55.4"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m1056.1 2314l50-65.2"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m1090.8 2268.4c0 0-4.3-26.1 17.4-50 13.1-14.4 85.6-54.2 95.6-28.2 10.9 28.2-60.8 93.4-113 78.2z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m1090.8 2268.4l71.6-55.4"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m1053.1 2165.8c0 0-4.4-26.1 17.4-50 13-14.4 85.6-54.2 95.6-28.3 10.8 28.3-60.9 93.5-113 78.3z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m1053.1 2165.8l71.5-55.4"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m1056.6 2168.8c0 0-26.4 1.6-47.9-22.5-12.9-14.5-44.9-90.8-18.1-98 29.3-7.9 86.6 70.3 66 120.5z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m1056.6 2168.8l-47.6-76.9"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m3088.3 3682l-46.2-533h-1094.8l-60.5 533z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m2417.7 1533.4c0 0-320.2 87.9-460 193.9-139.8 106-236.7 214.2-214.2 419.4 22.6 205.2 169.1 766.7 169.1 766.7 0 0-20.3 227.7-20.3 241.2 0 13.6-2.2 51.9 47.4 54.2 49.6 2.2 644.9 27 777.9 29.3 133.1 2.2 308.9-11.3 329.2-27.1 20.3-15.8 31.6-40.6 33.9-67.6 2.2-27.1 24.8-358.6 24.8-358.6l2.2-148.8c0 0 146.6-487 155.6-644.9 9-157.8-49.6-209.7-115-259.3-65.4-49.6-268.8-133.6-378.8-166.9-110-33.2-351.8-31.5-351.8-31.5z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m2496.7 2290.1c-16.3 219.7-45.2 624.4-42.7 693.7 3.6 96-35.5 124.4-35.5 160"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m2507.4 2148.5c0 0-2.9 37.4-7.3 96.5"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m2650.3 2430.6l20.4 241.6 114.7-8.2z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m2541.6 2851.9c0 0 280.2-44 301.1-39.4 20.8 4.6 164.4 74.1 185.2 78.7 20.9 4.7 39.4 13.9 39.4 13.9l31.4 26.3-10.6-79.5c0 0-41.7-51-134.3-88-92.6-37.1-138.9-16.2-159.8-9.3-20.8 7-252.4 97.3-252.4 97.3z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m2111.1 2640.5l728.3-2.2c0 0 234.5-22.6 243.5-24.8 9-2.3 101.5 22.5 110.5 29.3 9 6.7 9 27 4.5 47.3-4.5 20.3-4.5 20.3-4.5 20.3 0 0 6.8 36.1 6.8 51.9 0 15.8-18.1 20.3-20.3 27-2.3 6.8 13.5 31.6-4.5 47.4-18.1 15.8-18.1 15.8-18.1 15.8 0 0-2.2 42.8-11.2 54.1-9.1 11.3-36.1 31.6-47.4 24.8-11.3-6.8-6.8-24.8-6.8-36.1 0-11.2-4.5-22.5-18-22.5-13.5 0-15.8 11.3-85.7-6.8-69.9-18-146.6-78.9-153.3-81.2-6.8-2.2-617.9 162.4-798.3 184.9-180.3 22.6-196.1-2.2-202.9-31.5-6.8-29.3-18-99.2-18-99.2l-31.6-137.6z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m2584.4 1797.6c0 0 37.7-39.5 61.4-21.7 23.8 17.8 45.5 112.8 75.2 104.9 29.7-7.9 89.1-192 89.1-265.3 0-73.2-51.4-116.8-63.3-120.8-11.9-3.9-314.8-7.9-350.4 6-35.7 13.8-49.5 138.6-63.4 213.8-13.9 75.2 17.8 93 37.6 83.1 19.8-9.9 97-41.5 114.8-41.5 17.9 0 99 41.5 99 41.5z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m2787.2 1380.4c0 0-28.4 140.2-39.4 174.9-11 34.7-91.4 140.3-111.9 162.4-20.5 22-80.4 130.8-96.2 134-15.7 3.1-59.9-145.1-59.9-145.1 0 0-56.7-97.7-67.8-122.9-11-25.2-28.3-99.3-28.3-99.3 0 0 93 80.4 192.3 63 99.3-17.3 149.7-116.6 149.7-116.6z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m2402.3 1100.8c0 0-27.7-29.7-43.6 15.8-15.8 45.5 15.9 126.7 15.9 126.7z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m2407.3 1008.3c0 0-45.7 324.8-45.7 343.7 0 18.9-12.6 81.9 6.3 122.9 18.9 41 75.7 91.5 121.4 97.8 45.7 6.3 135.5-3.2 186-42.6 50.4-39.4 108.7-124.5 108.7-124.5 0 0 63.1-9.5 104.1-26.8 41-17.4 72.5-56.8 70.9-97.8-1.6-40.9-26.8-72.5-26.8-72.5l-23.6-44.1 63-118.2c0 0-36.2-67.8-152.9-132.4-116.6-64.7-220.7-85.2-269.5-85.2-48.9 0-110.4 20.5-127.7 59.9-17.3 39.5-14.2 119.8-14.2 119.8z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m2557.1 849.1c0 0 89.8 148.2 157.6 141.9 67.8-6.3 88.3-37.8 88.3-37.8l45.7 61.5c0 0-48.9 20.4-39.4 45.7 9.4 25.2 52 81.9 52 81.9l-34.7 148.2c0 0 26.8 4.7 31.5-4.7 4.8-9.5 28.4-67.8 28.4-67.8 0 0 9.5-6.3 20.5-9.5 11-3.1 25.2 0 25.2 0 0 0 17.4-58.3 23.7-59.9 6.3-1.5 69.3-18.9 93-80.4 23.6-61.4-12.7-159.2-94.6-236.4-82-77.2-255.4-97.7-264.8-111.9-9.5-14.2 44.1 6.3 33.1-25.2-11.1-31.6-80.4-72.5-168.7-28.4-88.3 44.1-75.7 93-66.2 108.8 9.5 15.7 9.5 15.7 9.5 15.7 0 0-74.1-25.2-126.1 6.3-52.1 31.5-77.3 94.6-53.6 100.9 23.6 6.3 53.6-7.9 53.6-7.9 0 0-31.6 52-22.1 63.1 9.4 11 58.3 55.1 58.3 55.1 0 0 18.9-110.3 58.3-126.1 39.4-15.7 91.5-33.1 91.5-33.1z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m2528.7 1061.9l14.2 45.8-80.4 151.3 85.1 33.1"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m2512.9 1044.6c0 0-37.8-29.9-69.3-22.1-31.6 7.9-12.7 12.6 9.4 20.5 22.1 7.9 66.2 28.4 59.9 1.6z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m2629.6 1038.3c0 0-36.3 9.5-19 17.3 17.4 7.9 69.4-7.8 89.9 0 20.5 7.9 47.3 34.7 45.7 22.1-1.6-12.6-14.2-37.8-42.6-47.3-28.3-9.4-74 7.9-74 7.9z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m2492.1 1114.6c-2.8 11.4-10.5 19.3-17.3 17.7-6.8-1.7-10-12.2-7.2-23.7 2.7-11.4 10.4-19.3 17.2-17.7 6.8 1.6 10 12.2 7.3 23.7z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m2663.9 1159.5c-2.8 11.4-10.5 19.3-17.3 17.7-6.7-1.6-10-12.2-7.2-23.6 2.7-11.5 10.5-19.4 17.2-17.8 6.8 1.7 10 12.3 7.3 23.7z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m2413.6 1311l64.6 42.6"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m3078.4 1693.5c0 0 223.2 85.7 266.1 214.2 42.8 128.5-11.3 290.9-33.8 358.5-22.6 67.7-162.4 331.5-184.9 394.6-22.6 63.2-56.4 139.8-56.4 139.8 0 0-31.6-189.4-117.3-306.6-85.7-117.3-105.9-223.3-105.9-223.3 0 0 155.5-275.1 196.1-360.8"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m2869.8 2223.1c0 0 45.7-22.9 60.9-15.2 15.2 7.6 210.6 111.6 236 230.9 25.4 119.2-12.7 220.7-35.5 263.9-22.9 43.1-66 126.8-99 137-33 10.1-60.9-261.4-129.4-403.5-68.5-142.1-33-213.1-33-213.1z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m2945.4 2092.6c0 0 40.6-137.6 56.3-191.7"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m2538.1 1604.2c0 0-63-88.3-111.9-146.6-48.8-58.3-99.3-93-116.6-88.3-17.4 4.7-23.7 22.1-12.6 42.6 11 20.5 63 66.2 72.5 78.8 9.4 12.6 23.6 58.3 23.6 58.3 0 0-45.7 3.2-53.6 12.6-7.9 9.5-18.9 34.7-18.9 34.7 0 0-15.8 7.9-23.6 20.5-7.9 12.6-7.9 15.8-9.5 22.1-1.6 6.3-23.6 17.3-22.1 45.7 1.6 28.3 28.4 69.3 37.9 88.2 9.4 19 78.8 102.5 91.4 116.7 12.6 14.2 85.1 140.3 104 182.8 18.9 42.6 201.8 536 255.4 610.1 53.6 74.1 152.9 145 206.5 170.2 53.6 25.2 91.4-17.3 116.6-70.9 25.3-53.6 47.3-160.8-1.5-283.8-48.9-122.9-145.1-228.5-219.2-291.6-74-63-212.8-220.7-228.5-249-15.8-28.4-36.3-91.5-36.3-91.5 0 0 41-119.7 44.2-148.1 3.1-28.4-12.6-78.8-7.9-100.9 4.7-22.1 23.6-66.2 31.5-85.1 7.9-18.9 34.7-50.5 20.5-64.7-14.2-14.1-72.5 3.2-93 36.3-20.5 33.1-48.9 100.9-48.9 100.9z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m2050.9 1945.6c4.8-25.1 8.3-42.4 8.3-42.4"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m2036.6 1686.7c0 0-119.5 15.8-243.5 148.8-124 133.1-69.9 448.8-58.6 514.1 11.3 65.4 29.3 266.1 29.3 266.1l317.9-106c0 0-51.8-354-56.3-385.5-2.3-16 6.4-72.3 15.5-124"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m1732.2 2545.8c0 0 31.6 169.1 47.4 178.2 15.8 9 261.6-58.7 288.6-63.2 27.1-4.5 42.9 2.3 42.9-20.3 0-22.5-22.6-128.5-36.1-146.5-13.5-18.1-306.7 20.3-331.5 27-24.8 6.8-11.3 24.8-11.3 24.8z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m1912.3 2415.1c91.2 36.3 162.7 78.9 162.7 78.9 0 0-76.7-144.4-108.3-173.7"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m1869.8 2399.3q13.6 4.7 26.8 9.7"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m2609.3 3137.4c58.3-20.8 112-43.7 144.4-66.2"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m2334.3 3217.8c0 0 124.6-29.6 242.8-69.2"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m2858.3 3061.8c-61.3 30.6-158.4 75.3-237.6 95.1"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m2918.3 3030.6c0 0-12.6 7-33.4 17.7"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m809 169.1c-536.6 258.5-638.4 1017.4-298.1 1473.6 71.2 95.3 164.2 175.7 274.3 222.4 376.2 159.5 677.4-157.6 860.7-448.9 292.6-465.1 329.2-580.1 324-501.7-5.3 78.4 130.6 162 209-250.8 100.2-527.7-638.7-647.8-1012.6-598.1-125.4 16.7-246.9 50.3-357.3 103.5z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m2010 1060.6c-31.4 56.8-29.3 118.2 4.8 137.1 34.1 18.8 87.2-11.9 118.7-68.7 31.4-56.8 29.3-118.2-4.8-137.1-34.1-18.8-87.2 11.9-118.7 68.7z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m2189.5 1140.6c-18.5 33.6-17.3 69.9 2.9 81 20.1 11.2 51.5-7 70.1-40.6 18.6-33.5 17.3-69.8-2.8-81-20.2-11.1-51.6 7.1-70.2 40.6z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m839.9 119.7c-536.6 258.4-638.4 1017.4-298.1 1473.5 71.2 95.4 164.2 175.8 274.3 222.5 376.2 159.5 677.4-157.6 860.7-449 292.6-465 329.2-580 324-501.6-5.3 78.4 130.6 162 209-250.9 100.2-527.7-638.7-647.7-1012.6-598-125.4 16.7-246.9 50.3-357.3 103.5z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m2040.9 1011.2c-31.4 56.8-29.3 118.1 4.8 137 34.1 18.9 87.2-11.8 118.7-68.7 31.4-56.8 29.3-118.1-4.8-137-34.1-18.9-87.2 11.9-118.7 68.7z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m2220.4 1091.2c-18.5 33.6-17.3 69.8 2.9 81 20.1 11.1 51.5-7 70.1-40.6 18.6-33.6 17.3-69.8-2.8-81-20.2-11.2-51.6 7-70.2 40.6z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "j",
    d: "m556.6 691.6v-105.7h64.3c3.1-17.7 7.7-34.8 13.7-51.3l-55.6-32.2 52.8-91.5 55.7 32.2c11.5-13.6 24-26.2 37.6-37.6l-32.1-55.7 91.5-52.8 32.1 55.6c16.5-6 33.7-10.5 51.4-13.6v-64.4h105.7v64.4c17.7 3.1 34.9 7.7 51.4 13.7l32.1-55.6 91.5 52.8-32.2 55.7c13.6 11.5 26.2 24 37.6 37.6l55.7-32.1 52.9 91.5-55.7 32.1c6 16.5 10.6 33.7 13.7 51.4h64.3v105.7h-64.4c-3.1 17.7-7.6 34.9-13.6 51.4l55.6 32.1-52.9 91.5-55.7-32.2c-11.4 13.6-24 26.2-37.6 37.6l32.2 55.7-91.5 52.8-32.2-55.6c-16.5 6-33.7 10.5-51.4 13.6v64.4h-105.6v-64.4c-17.7-3.1-34.9-7.6-51.4-13.7l-32.1 55.7-91.6-52.9 32.2-55.7c-13.6-11.4-26.1-24-37.6-37.6l-55.7 32.2-52.8-91.6 55.6-32.1c-6-16.5-10.5-33.7-13.6-51.4zm561.1-52.7c0-108.9-88-196.9-196.9-196.9-108.9 0-196.9 88-196.9 196.9 0 108.8 88 196.9 196.9 196.9 108.9 0 196.9-88.1 196.9-196.9z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "j",
    d: "m706.5 1312.7v-85.9h52.3c2.6-14.4 6.3-28.4 11.1-41.8l-45.2-26.1 43-74.4 45.3 26.1c9.3-11 19.5-21.2 30.6-30.5l-26.2-45.3 74.4-42.9 26.1 45.2c13.4-4.9 27.4-8.6 41.8-11.1v-52.3h85.9v52.3c14.4 2.5 28.4 6.2 41.8 11.1l26.1-45.2 74.4 43-26.2 45.3c11.1 9.3 21.3 19.5 30.6 30.5l45.3-26.1 42.9 74.4-45.2 26.1c4.9 13.4 8.6 27.4 11.1 41.8h52.3v85.9h-52.3c-2.6 14.4-6.2 28.4-11.1 41.8l45.2 26.1-43 74.4-45.3-26.2c-9.3 11.1-19.5 21.3-30.6 30.6l26.2 45.3-74.4 42.9-26.1-45.2c-13.4 4.9-27.4 8.6-41.8 11.1v52.3h-85.9v-52.4c-14.4-2.5-28.4-6.2-41.8-11.1l-26.1 45.2-74.4-42.9 26.2-45.3c-11.1-9.3-21.3-19.5-30.6-30.6l-45.3 26.2-42.9-74.4 45.2-26.1c-4.9-13.5-8.6-27.4-11.1-41.8zm456.2-42.9c0-88.5-71.6-160.1-160.1-160.1-88.5 0-160.1 71.6-160.1 160.1 0 88.5 71.6 160.1 160.1 160.1 88.5 0 160.1-71.6 160.1-160.1z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "j",
    d: "m1252.4 1116.3v-65.4h39.8c2-11 4.8-21.6 8.5-31.9l-34.4-19.8 32.7-56.7 34.5 19.9c7.1-8.4 14.9-16.2 23.3-23.3l-19.9-34.5 56.6-32.7 19.9 34.5c10.2-3.7 20.9-6.6 31.8-8.5v-39.8h65.5v39.8c10.9 2 21.6 4.8 31.8 8.5l19.9-34.4 56.7 32.7-20 34.5c8.4 7.1 16.2 14.9 23.3 23.3l34.5-19.9 32.7 56.6-34.4 19.9c3.7 10.2 6.5 20.9 8.4 31.9h39.9v65.4h-39.9c-1.9 10.9-4.7 21.6-8.5 31.8l34.5 19.9-32.7 56.7-34.6-20c-7 8.5-14.8 16.2-23.2 23.3l19.9 34.5-56.7 32.7-19.9-34.4c-10.2 3.7-20.9 6.5-31.8 8.4v39.9h-65.4v-39.9c-11-1.9-21.7-4.7-31.9-8.5l-19.9 34.5-56.6-32.7 19.9-34.6c-8.4-7-16.2-14.8-23.3-23.2l-34.5 19.9-32.7-56.7 34.5-19.9c-3.7-10.2-6.6-20.8-8.5-31.8zm347.5-32.7c0-67.4-54.5-121.9-121.9-121.9-67.5 0-122 54.5-122 121.9 0 67.5 54.5 122 122 122 67.4 0 121.9-54.5 121.9-122z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "j",
    d: "m1485.5 510.9v-65.4h39.8c1.9-11 4.8-21.6 8.5-31.8l-34.5-19.9 32.8-56.7 34.5 20c7-8.5 14.8-16.2 23.2-23.3l-19.9-34.5 56.7-32.7 19.9 34.4c10.2-3.7 20.9-6.5 31.8-8.4v-39.9h65.5v39.9c10.9 1.9 21.6 4.7 31.8 8.5l19.9-34.5 56.6 32.7-19.9 34.6c8.4 7 16.2 14.8 23.3 23.2l34.5-19.9 32.7 56.7-34.5 19.9c3.8 10.2 6.6 20.8 8.5 31.8h39.8v65.4h-39.8c-2 11-4.8 21.6-8.5 31.9l34.4 19.8-32.7 56.7-34.5-19.9c-7.1 8.4-14.8 16.2-23.3 23.3l20 34.5-56.7 32.7-19.9-34.5c-10.2 3.7-20.9 6.6-31.8 8.5v39.8h-65.5v-39.9c-10.9-1.9-21.6-4.7-31.8-8.4l-19.9 34.4-56.7-32.7 20-34.5c-8.4-7.1-16.2-14.9-23.3-23.3l-34.5 19.9-32.7-56.6 34.4-19.9c-3.7-10.3-6.5-20.9-8.4-31.9zm347.5-32.6c0-67.5-54.5-122-122-122-67.4 0-121.9 54.5-121.9 122 0 67.4 54.5 121.9 121.9 121.9 67.5 0 122-54.5 122-121.9z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManthink);
export default __webpack_public_path__ + "static/media/manthink.e7adf458f1c7c301e2b3bee72cd5bf26.svg";
export { ForwardRef as ReactComponent };